import { render, staticRenderFns } from "./ExpressOrderTableUser.vue?vue&type=template&id=22780fea&scoped=true"
import script from "./ExpressOrderTableUser.vue?vue&type=script&lang=js"
export * from "./ExpressOrderTableUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22780fea",
  null
  
)

export default component.exports